import { render, staticRenderFns } from "./WbsFilter.vue?vue&type=template&id=2e2c3d72&scoped=true"
import script from "./WbsFilter.vue?vue&type=script&lang=js"
export * from "./WbsFilter.vue?vue&type=script&lang=js"
import style0 from "./WbsFilter.vue?vue&type=style&index=0&id=2e2c3d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c3d72",
  null
  
)

export default component.exports